import withAnalytics from 'commons-vdp/components/withAnalytics/withAnalytics.jsx';
import withAnalyticsV25 from 'commons-vdp/components/withAnalyticsV25/withAnalyticsV25.jsx';
import SharingBar from 'commons-vdp/components/SharingBar/SharingBar.jsx';

export { withAnalytics, withAnalyticsV25, SharingBar };

export default { withAnalytics, withAnalyticsV25, SharingBar };
